import React, { Fragment } from 'react'
import { Intro, MultipleChoice } from 'cvs-core'
import image from '../../assets/images/U2-T1-1-4a.svg'
import agree from '../../assets/images/face4.svg'
import neutral from '../../assets/images/face3.svg'
import disagree from '../../assets/images/face2.svg'

const options = [
  {
    label: 'Agree',
    image: agree,
  },
  {
    label: 'Neutral',
    image: neutral,
  },
  {
    label: 'Disagree',
    image: disagree,
  },
]

const data = [
  {
    inputType: 'radio',
    question: 'I can identify misleading advertisements.',
    options,
    image,
  },
  {
    inputType: 'radio',
    question: 'I am a critical observer of what I see on social media.',
    options,
  },
  {
    inputType: 'radio',
    question: 'I know resources that can help those who start vaping to stop.',
    options,
  },
]

const feedback = {
  success: {
    title: 'Thanks.',
    body: 'Let’s start the module!',
  },
}

export default {
  title: 'Confidence Ranking',
  path: '/prepare/confidence-ranking',
  content: (
    <Fragment>
      <Intro
        title="What Do You Think?"
        lead="Select the image that matches how strongly you agree or disagree with the statement."
        direction="Select the best answer."
      />
      <MultipleChoice data={data} feedback={feedback} />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Prepare/ConfidenceRanking.js